<app-main-menu></app-main-menu>
<router-outlet></router-outlet>
<app-footer></app-footer>
